import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import ManageAiVariationsModal from '../../campaign_creation_rtb/components/articles/components/manageAiVariationsButton/manageAiVariationsModal/ManageAiVariationsModal'

const ExternalAdApproval: React.FunctionComponent<RouteComponentProps<{ token: string }>> = (props) => {

	// TODO: Add ad format data to token and parse it here
	const parseTokenForAdFormat = (token: string) => {
		if (token) {
			return 2
		}
		return 1
	}
	return (
		<div className="page-content">
			<div id="maincontainer" className="container-fluid">
				<ManageAiVariationsModal
					token={props.match.params.token}
					hideModal={() => { }}
					adFormat={parseTokenForAdFormat(props.match.params.token)}
				/>
			</div>
		</div>
	)
}

export default ExternalAdApproval
